var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row",
      class: { disabled: _vm.loading.delete || _vm.loading.disable },
      attrs: { "data-id": _vm.user.id }
    },
    [
      _c(
        "div",
        {
          staticClass: "avatar",
          class: {
            "icon-loading-small":
              _vm.loading.delete || _vm.loading.disable || _vm.loading.wipe
          }
        },
        [
          !_vm.loading.delete && !_vm.loading.disable && !_vm.loading.wipe
            ? _c("img", {
                attrs: {
                  alt: "",
                  width: "32",
                  height: "32",
                  src: _vm.generateAvatar(_vm.user.id, 32),
                  srcset:
                    _vm.generateAvatar(_vm.user.id, 64) +
                    " 2x, " +
                    _vm.generateAvatar(_vm.user.id, 128) +
                    " 4x"
                }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "name" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.user.id) + "\n\t\t"),
        _c("div", { staticClass: "displayName subtitle" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value:
                    _vm.user.displayname.length > 20
                      ? _vm.user.displayname
                      : "",
                  expression:
                    "user.displayname.length > 20 ? user.displayname : ''"
                }
              ],
              staticClass: "cellText"
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user.displayname) + "\n\t\t\t")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "mailAddress" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value:
                  _vm.user.email !== null && _vm.user.email.length > 20
                    ? _vm.user.email
                    : "",
                expression:
                  "user.email !== null && user.email.length > 20 ? user.email : ''"
              }
            ],
            staticClass: "cellText"
          },
          [_vm._v("\n\t\t\t" + _vm._s(_vm.user.email) + "\n\t\t")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "groups" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.userGroupsLabels) + "\n\t")
      ]),
      _vm._v(" "),
      _vm.subAdminsGroups.length > 0 && _vm.settings.isAdmin
        ? _c("div", { staticClass: "subAdminsGroups" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.userSubAdminsGroupsLabels) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "userQuota" }, [
        _c("div", { staticClass: "quota" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.userQuota) +
              " (" +
              _vm._s(_vm.usedSpace) +
              ")\n\t\t\t"
          ),
          _c("progress", {
            staticClass: "quota-user-progress",
            class: { warn: _vm.usedQuota > 80 },
            attrs: { max: "100" },
            domProps: { value: _vm.usedQuota }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.showConfig.showLanguages
        ? _c("div", { staticClass: "languages" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.userLanguage.name) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfig.showUserBackend || _vm.showConfig.showStoragePath
        ? _c("div", { staticClass: "userBackend" }, [
            _vm.showConfig.showUserBackend
              ? _c("div", { staticClass: "userBackend" }, [
                  _vm._v("\n\t\t\t" + _vm._s(_vm.user.backend) + "\n\t\t")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showConfig.showStoragePath
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.user.storageLocation,
                        expression: "user.storageLocation"
                      }
                    ],
                    staticClass: "storageLocation subtitle"
                  },
                  [
                    _vm._v(
                      "\n\t\t\t" + _vm._s(_vm.user.storageLocation) + "\n\t\t"
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfig.showLastLogin
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.auto",
                  value: _vm.userLastLoginTooltip,
                  expression: "userLastLoginTooltip",
                  modifiers: { auto: true }
                }
              ],
              staticClass: "lastLogin"
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.userLastLogin) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "userActions" }, [
        _vm.canEdit && !_vm.loading.all
          ? _c(
              "div",
              { staticClass: "toggleUserActions" },
              [
                _c(
                  "Actions",
                  [
                    _c(
                      "ActionButton",
                      {
                        attrs: { icon: "icon-rename" },
                        on: { click: _vm.toggleEdit }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.t("settings", "Edit User")) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "userPopoverMenuWrapper" }, [
                  _c("button", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideMenu,
                        expression: "hideMenu"
                      }
                    ],
                    staticClass: "button icon-more",
                    attrs: {
                      "aria-label": _vm.t(
                        "settings",
                        "Toggle user actions menu"
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("toggleMenu")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "popovermenu",
                      class: { open: _vm.openedMenu },
                      attrs: { "aria-expanded": _vm.openedMenu }
                    },
                    [_c("PopoverMenu", { attrs: { menu: _vm.userActions } })],
                    1
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "feedback",
            style: { opacity: _vm.feedbackMessage !== "" ? 1 : 0 }
          },
          [
            _c("div", { staticClass: "icon-checkmark" }),
            _vm._v("\n\t\t\t" + _vm._s(_vm.feedbackMessage) + "\n\t\t")
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }